import './Guide.css'

const Guide = ({onClick, image, title, level, duration, prerequisites, description, available}) => {
    return (
        <div className={available ? 'guide-container' : 'guide-container not-available-guide'}>
            <img className={available ? 'guide-image' : 'guide-image not-available-image'} src={image} alt='guide-teaser-picture'></img>
            <div className='guide-text-content'>
                <div className='guide-head-container'>
                    <div className='guide-title-date-container'>
                        <span className='guide-title'>{title}</span>
                    </div>
                    <span className='guide-level'>{level} | {duration} | {prerequisites}</span>
                </div>
                <span className='guide-description'>{description}</span>
                <span 
                    className={available ? 'guide-link' : 'not-available-link'} 
                    onClick={onClick}
                >
                    {available ? 'Open Guide' : 'Coming soon 🔥'}
                </span>
            </div>
        </div>
    )
}

export default Guide